// extracted by mini-css-extract-plugin
module.exports = {"title":"WeatherSevenDays_title__2OE6i","list":"WeatherSevenDays_list__3vtAS","temp":"WeatherSevenDays_temp__LhZS4"};